import { css } from '@emotion/react'
import { Flow, InfoLabel, Theme, useTheme } from 'bold-ui'
import { HLabel } from 'components/HLabel'

import { AnexoArquivoRowModel } from '../../model-anexoArquivos'

export function AnexoArquivosAccordionPanel(props: { readonly row: AnexoArquivoRowModel }) {
  const { row } = props
  const { nome } = row.atendimentoProfissional.lotacao.profissional
  const cbo = row.atendimentoProfissional.lotacao.cbo.nome

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Flow direction='vertical' style={styles.container} gap={1}>
      <InfoLabel title='Observações' placeholder='-'>
        {row.observacao}
      </InfoLabel>
      <HLabel title='Anexado por:'>
        {nome.titleCase()} | {cbo.toUpperCase()}
      </HLabel>
    </Flow>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    background: ${theme.pallete.gray.c90};
    padding: 1rem;
  `,
})
